import { ABTestConfig } from '@hakimo-ui/hakimo/types';
import {
  FullScreenExitIcon,
  FullScreenIcon,
  MenuDropdown,
} from '@hakimo-ui/hakimo/ui-elements';
import { useCanShareAlarmGroup } from '@hakimo-ui/hakimo/util';
import { EllipsisVerticalIcon, LinkIcon } from '@heroicons/react/24/outline';
import { ServerIcon, ShareIcon } from '@heroicons/react/24/solid';

interface Props {
  isFullScreen?: boolean;
  toggleFullScreen: () => void;
  onCopyLink: () => void;
  onShare?: () => void;
  abTestConfig?: ABTestConfig;
  onOpenInferenceServerABTest?: () => void;
}

export function MenuActions(props: Props) {
  const {
    isFullScreen,
    toggleFullScreen,
    onCopyLink,
    onShare,
    abTestConfig,
    onOpenInferenceServerABTest,
  } = props;
  const canShareAlarm = useCanShareAlarmGroup();

  const alarmMenuOptions = [
    {
      dataTestId: 'btn-copy-alarm-group-link',
      name: 'Copy link',
      onClick: onCopyLink,
      icon: <LinkIcon className="h-4 w-4" />,
    },
    {
      dataTestId: 'btn-toggle-fullscreen-view',
      name: `${isFullScreen ? 'Exit ' : ''} Fullscreen`,
      onClick: toggleFullScreen,
      group: 'viewMode',
      icon: (
        <span>
          {isFullScreen ? (
            <FullScreenExitIcon className="dark:fill-dark-text h-5 w-5" />
          ) : (
            <FullScreenIcon className="dark:fill-dark-text h-5 w-5" />
          )}
        </span>
      ),
    },
  ];
  const inferenceABTestEnabled =
    abTestConfig && abTestConfig['inference_server'];
  if (inferenceABTestEnabled) {
    alarmMenuOptions.push({
      dataTestId: 'btn-inference-server',
      name: 'Inference server A/B test',
      onClick: () => onOpenInferenceServerABTest?.(),
      icon: <ServerIcon className="h-4 w-4" />,
    });
  }
  if (canShareAlarm && onShare) {
    alarmMenuOptions.splice(1, 0, {
      dataTestId: 'btn-share-alarm-group',
      name: 'Share alarm',
      onClick: onShare,
      icon: <ShareIcon className="h-4 w-4" />,
    });
  }

  const menuButton = (
    <EllipsisVerticalIcon className="h-5 w-5" data-testid="menu-button" />
  );

  return (
    <span className="mr-1">
      <MenuDropdown items={alarmMenuOptions} menuButton={menuButton} />
    </span>
  );
}

export default MenuActions;
